import React from "react";
import { Link } from "react-router-dom";

const courses = [
  "Fullstack Developer Course",
  "MERN Stack Developer Course",
  "Data Science Course",
  "Artificial Intelligence & Machine Learning Course",
  "Cyber Security Course",
  "Augmented Reality & Virtual Reality (AR/VR) Courses",
  "Block Chain Course",
  "PowerBI Course",
  "Amazon Web Services(AWS) Course",
  "ServiceNow Courses",
  "SAP Courses",
];

const TrendingCourses = () => {
  return (
    <div className="ibix-trending-courses">
      <h2 className="ibix-trending-title">Trending Courses</h2>
      <div className="ibix-trending-list">
        {courses.map((course, index) => (
          <span key={index} className="ibix-course-item">
            {course} Hyderabad {index < courses.length - 1 && "| "}
          </span>
        ))}
      </div>
    </div>
  );
};

const Footer = () => {
  const phoneNumber = "+919100884508";
  const message = "Hello, I'm interested to know more about IBIX courses!";

  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <footer className="ibix-footer">
      <div className="ibix-footer-top">
        <div className="ibix-footer-section ibix-about-section">
          <h2 className="ibix-footer-heading">IBIX Qodify Technologies</h2>
          <p className="ibix-footer-tagline">
            Transforming Careers Through Technology
          </p>
          <p className="ibix-footer-description">
            Transforming careers through industry-leading tech education. Join
            thousands of successful professionals who achieved their dream jobs
            with us.
          </p>
          <div className="ibix-social-icons">
            <a
              href="https://www.facebook.com/Iqteche"
              target="_blank"
              rel="noreferrer"
              className="ibix-social-link ibix-facebook"
              aria-label="Visit our Facebook page"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://x.com/IbixQodify"
              target="_blank"
              rel="noreferrer"
              className="ibix-social-link ibix-twitter"
              aria-label="Visit our Twitter page"
            >
              <i className="fab fa-x-twitter"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/ibix-qodify-technologies/?viewAsMember=true"
              target="_blank"
              rel="noreferrer"
              className="ibix-social-link ibix-linkedin"
              aria-label="Visit our LinkedIn page"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://www.instagram.com/ibix_qodify64/"
              target="_blank"
              rel="noreferrer"
              className="ibix-social-link ibix-instagram"
              aria-label="Visit our Instagram page"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://youtube.com/@ibixqodifytechnologies?feature=shared"
              target="_blank"
              rel="noreferrer"
              className="ibix-social-link ibix-youtube"
              aria-label="Visit our YouTube channel"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <button
              onClick={handleWhatsAppClick}
              className="ibix-social-link ibix-whatsapp"
              aria-label="Contact us on WhatsApp"
            >
              <i className="fab fa-whatsapp"></i>
            </button>
          </div>
        </div>

        <div className="ibix-footer-section ibix-company-section">
          <h3 className="ibix-section-title">Company</h3>
          <ul className="ibix-footer-links">
            <li className="ibix-footer-link-item">
              <Link to="/about-us" className="ibix-footer-link">
                About Us
              </Link>
            </li>
            <li className="ibix-footer-link-item">
              <Link to="/careers" className="ibix-footer-link">
                Careers
              </Link>
            </li>
            <li className="ibix-footer-link-item">
              <Link to="/services" className="ibix-footer-link">
                Services
              </Link>
            </li>
            <li className="ibix-footer-link-item">
              <Link to="/contact" className="ibix-footer-link">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div className="ibix-footer-section ibix-contact-section">
          <h3 className="ibix-section-title">Contact Us</h3>
          <div className="ibix-contact-info">
            <p className="ibix-contact-item">
              <i className="fas fa-envelope ibix-contact-icon"></i>
              <span>info@ibixqt.in</span>
            </p>
            <p className="ibix-contact-item">
              <i className="fas fa-phone ibix-contact-icon"></i>
              <span>091008 84508</span>
            </p>
            <p className="ibix-contact-item ibix-address">
              <i className="fas fa-map-marker-alt ibix-contact-icon"></i>
              <span>
                496, Izzathnagar, Hyderabad,
                <br />
                Kothaguda, Telangana 500084
              </span>
            </p>
          </div>
        </div>
      </div>

      <div className="ibix-states-section">
        <h5 className="ibix-states-title">Course Locations</h5>
        <div className="ibix-states-list">
          <span className="ibix-state-item">Andhra Pradesh</span>
          <span className="ibix-state-item">Telangana</span>
          <span className="ibix-state-item">Tamilnadu</span>
          <span className="ibix-state-item">Kerala</span>
          <span className="ibix-state-item">Karnataka</span>
        </div>
      </div>

      <div className="ibix-footer-middle">
        <div className="ibix-payment-methods">
          <span className="ibix-payment-title">Accepted Payment Methods:</span>
          <div className="ibix-payment-badges">
            <span className="ibix-payment-badge ibix-visa">VISA</span>
            <span className="ibix-payment-badge ibix-mastercard">MASTER</span>
            <span className="ibix-payment-badge ibix-upi">UPI</span>
            <span className="ibix-payment-badge ibix-paytm">PAYTM</span>
          </div>
        </div>

        <div className="ibix-policies">
          <Link to="/terms-and-privacy" className="ibix-policy-link">
            Terms & Conditions - Privacy Policy
          </Link>
        </div>
      </div>

      <TrendingCourses />

      <div className="ibix-footer-bottom">
        <div className="ibix-footer-note">
          <p className="ibix-copyright">
            © 2026 IBIX Qodify Technologies. All rights reserved.
          </p>
          <p className="ibix-credits">
            Empowering Careers Through Innovative Technology Education
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
